export const projectItems = [
  {
    title: "WellTalk | Mental Health Web App",
    description: "WellTalk is a mental health web app that helps students track their mental health journey. It allows students to track their mood, sleep, and other mental health metrics.",
    tags: ["ReactJS", "Node.js", "Spring Boot", "Tailwind CSS", "Vite"]
  },
  {
    title: "CI/CD Test Automation",
    description: "Distributed test pipeline with GitHub Actions, database queue, and parallel PHP workers. Reduced CI time by 50%.",
    tags: ["GitHub Actions", "PHPUnit", "MySQL"]
  },
  {
    title: "English Learning Assistant",
    description: "Structured prompt templates with RAG for adaptive conversations and intent handling.",
    tags: ["Prompt Engineering", "RAG", "LLM", "Dify"]
  },
  {
    title: "Support Chatbot",
    description: "AI chatbot handling FAQs and guidance with RAG-powered knowledge base integration.",
    tags: ["LLM", "RAG", "OpenAI", "Dify", "CakePHP"]
  },
  {
    title: "Automated AI Videos Generator",
    description: "Automated pipeline for generating video content using AI models for visuals, scenes, and scripts.",
    tags: ["n8n", "GoogleFlow", "OpenAI"]
  },
  {
    title: "Automated Youtube / Tiktok Data Scraper",
    description: "High-performance scraper for gathering analytics and trending data from social media platforms.",
    tags: ["n8n","OpenAI", "Apify"]
  }
];
